module.exports = __webpack_public_path__ + "static/media/plotter3.beb2ee02.png";